export enum NoteType {
	Meeting = 1,
	PhoneCall = 2,
	Other = 99
}